module.exports = __webpack_public_path__ + "static/media/grad.4e783c1b.gif";